import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { Props } from './CrossPromoVkMusicFakedoorModal.types';

export const renderCrossPromoVkMusicFakedoorModal = (data: Props) => {
    openPopupHelper({
        popupName: popupNames.CROSS_PROMO_VK_MUSIC_FAKEDOOR_MODAL,
        data: {
            ...data,
            onCrossClick: data.onClose,
        },
    });
};
